import { root } from './schedules';

export const schedules = {
  ...root,
};
